<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-location-pin"></i> -->
                    <input v-model="invoice.invoice_number" class="form__input--text" type="text" required :class="{ 'has-value': invoice.invoice_number }"/>
                    <label class="form__label">{{$t('forms.invoice.invoice_number')}}</label>
                </div>
                <div class="form__item">
                    <!-- <i class="form__icon icons icon-location-pin"></i> -->
                    <input v-model="invoice.declaration_reference" class="form__input--text" type="text" required :class="{ 'has-value': invoice.declaration_reference }"/>
                    <label class="form__label">{{$t('forms.invoice.declaration_reference')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="invoice.invoice_date" class="form__input--text has-value" required type="date"/>
                    <label class="form__label">{{$t('forms.invoice.invoice_date')}}</label>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import Invoice from '@/models/Invoice';

    @Component
    export default class InvoiceForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Invoice, default() {
            return new Invoice();
        } })
        invoice;

        created() {
            this.errors = [];
        }

        get isSaveDisabled() {
            return !this.invoice.invoice_number || !this.invoice.declaration_reference || !this.invoice.invoice_date;
        }

        saveLoading = false;


        get loading () {
            return this.saveLoading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;

            this.invoice.rows = [];

            this.invoice.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/InvoiceForm.vue